import React, {useEffect} from 'react';

const ReduxInputComponent = ({input, numbersOnly, ...otherProps}) => {
    // console.log('[_ReduxInputComponent]', input, otherProps);
    const handleChange = (event) => {
        const value = event.target.value;
        if (numbersOnly) {
            const numbersOnlyValue = value.replace(/[^0-9]/g, '');
            input.onChange(numbersOnlyValue);
            return;
        }
        input.onChange(value);
    };

    useEffect(() => {
        const value = input.value;

        if (numbersOnly) {
            const numbersOnlyValue = value.replace(/[^0-9]/g, '');
            if (numbersOnlyValue !== value) {
                // console.log('[_ReduxInputComponent] useEffect numbersOnly', value, numbersOnlyValue);
                input.onChange(numbersOnlyValue);
            }
        }
    }, []);

    return (
        <input
            {...input}
            {...otherProps}
            onChange={handleChange}
        />
    );
};

export default ReduxInputComponent;